<template>
    <div>
        <vForm :label-width="120" ref="baseform" :model="formData" class="margin-15 clearfix">
            <vCol span="24">
                <vFormItem label="主题" prop="title" :rules="required">
                    <vInput v-model="formData.title" readonly disabled></vInput>
                </vFormItem>
            </vCol>
            <vCol span="24">
                <vFormItem label="发件人" prop="senderEmail" :rules="required" >
                    <vInput v-model="formData.senderEmail" readonly disabled></vInput>
                </vFormItem>
            </vCol>
            <vCol span="24">
                <vFormItem label="收件人" prop="recipientEmail" :rules="required">
                    <vInput v-model="formData.recipientEmail"></vInput>
                </vFormItem>
            </vCol>
            <vCol span="24">
                <vFormItem label="抄送">
                    <vInput v-model="formData.copyEmail"></vInput>
                </vFormItem>
            </vCol>
            <vCol span="24">
                <vFormItem>
                    <div style="border: 1px solid #dcdee2; padding: 5px" >
                        <p>Dear All,</p>
                        <div>
                            <p style="margin-bottom: 10px">以下是贵司{{startTime}}至{{endTime}}账单，请尽快登录系统查看并核对。</p>
                            <div style="margin-bottom: 10px">
                                <p style="margin-bottom: -10px">账单编号：{{billNo}} 总金额{{totalCost}} {{currency}}</p>
                                <a href="https://fb.onepinnovate.com/home/newbigaccount/storageorderclient/billdetail">点击查看：客户账单明细</a>
                            </div>
                            <p style="color:red">请在账单发送日5个工作日内核对，逾期则自动默认账单无误。</p>谢谢配合。
                        </div>
                    </div>
                </vFormItem>
            </vCol>
        </vForm>
        <div class="text-right">
            <vButton theme="primary" class="margin-right-10" @click="submit">{{$t('global.modal.confirm', { defaultValue: "确定" })}}</vButton>
            <vButton @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: "取消" })}}</vButton>
        </div>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { HttpSendEmail, HttpGetEmailMessage } from "@/service/newbigaccount";
export default {
    props:['activeid','boxtype'],
    components: {
    },
    data(){
        return {
            required: [
                {
                    required: true,
                    message: "该信息不能为空,请填写",
                },
            ],
            formData:{},
            loading: false,
            startTime: '',
            endTime: '',
            billNo: '',
            totalCost: '',
            currency: '',
        }
    },
    async created() {
        this.loading = true;
        await HttpGetEmailMessage({id:this.activeid})
            .then(res => {
                this.loading = false;
                this.formData = res.data;
                this.startTime = res.data.billEntity.startTime;
                this.endTime = res.data.billEntity.endTime;
                this.billNo = res.data.billEntity.billNo;
                this.totalCost = res.data.billEntity.totalCost;
                this.currency = res.data.billEntity.currency;
            }),err=>{
                this.loading = false;
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }
    },
    computed:{
    },
    methods:{
        async submit(){
            const valid = await this.$refs.baseform.validate();
			if(!valid) {
                this.$VMessage.error(this.$t('fbb.headlogistics.info_empty', { defaultValue: '必填项不能为空' }))
                return;
            }
            const regEmail = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
            if(this.formData.recipientEmail){
                const receiveEmail = this.formData.recipientEmail.split(',');
                let receiveTrue = true;
                for( let i = 0 ; i < receiveEmail.length ; i++){
                    if(!regEmail.test(receiveEmail[i])){
                        receiveTrue = false;
                        this.$VMessage.error('请填写正确的接收人邮箱！');
                        break;
                    }
                }
                if(!receiveTrue) return
            }
            if( this.formData.copyEmail){
                const copyEmail = this.formData.copyEmail.split(',');
                let copyTrue = true;
                for( let i = 0 ; i < copyEmail.length ; i++){
                    if(!regEmail.test(copyEmail[i])){
                        copyTrue = false;
                        this.$VMessage.error('请填写正确的抄送人邮箱！');
                        break;
                    }
                }
                if(!copyTrue) return
            }
            this.loading = true;
            HttpSendEmail({
                id: this.activeid,
                title: this.formData.title,
                senderEmail: this.formData.senderEmail,
                recipientEmail: this.formData.recipientEmail,
                copyEmail: this.formData.copyEmail,
            }).then(res=>{
                this.loading = false;
                this.$VMessage.success(res.message);
                this.$emit('on-update');
                this.cancel();
            },err=>{
                this.loading = false;
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            this.$emit('on-close');
        }
    }
}
</script>
